var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVivesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450.27 595.28",
    style: {
      enableBackground: "new 0 0 450.27 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#ED1C24;stroke:#E50001;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 229.6546,
    cy: 1091.1978,
    r: 122.4408,
    gradientTransform: "matrix(1 0 0 0.1105 0 359.5325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7A9AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1093,
    style: {
      stopColor: "#B8B9BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3476,
    style: {
      stopColor: "#D7D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8013,
    style: {
      stopColor: "#FAFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.13,480.11c0,7.48-54.82,13.52-122.48,13.52c-67.62,0-122.46-6.05-122.46-13.52 c0-7.45,54.84-13.53,122.46-13.53C297.31,466.58,352.13,472.66,352.13,480.11z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.53,151.58c-58.08-58.08-152.24-58.08-210.32,0c-58.08,58.08-58.08,152.24,0,210.32c0,0,0,0,0,0 l78.81,78.81h0c0.02,0.02,0.04,0.04,0.06,0.06c14.52,14.52,38.06,14.52,52.58,0c0.01-0.01,0.02-0.02,0.03-0.03l0,0l78.84-78.84 C392.61,303.82,392.61,209.66,334.53,151.58"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.95,273.24c2.02,0.62,3.59,1.34,4.72,2.15c1.12,0.82,1.69,2.16,1.69,4.02c0,1.32-0.37,2.39-1.11,3.2 c-0.74,0.82-1.65,1.48-2.73,1.98c-1.09,0.51-2.27,0.85-3.55,1.05c-1.28,0.2-2.46,0.29-3.55,0.29c-2.49,0-4.87-0.25-7.16-0.76 c-2.29-0.5-4.71-1.26-7.28-2.27c-0.93,2.02-1.69,4.09-2.27,6.23c-0.58,2.14-0.95,4.25-1.11,6.35c1.63,0.62,3.14,1.13,4.54,1.51 c1.4,0.39,2.81,0.72,4.25,0.99c1.44,0.27,2.93,0.46,4.48,0.58c1.55,0.12,3.26,0.18,5.12,0.18c4.11,0,7.8-0.52,11.06-1.57 c3.26-1.05,6.03-2.48,8.32-4.31c2.29-1.82,4.03-3.98,5.24-6.46c1.2-2.48,1.8-5.16,1.8-8.03c0-2.79-0.35-5.16-1.05-7.1 c-0.7-1.94-1.67-3.57-2.91-4.89c-1.24-1.32-2.74-2.42-4.48-3.32c-1.75-0.89-3.71-1.65-5.88-2.27l-6.63-1.98 c-1.94-0.62-3.43-1.28-4.48-1.98c-1.05-0.7-1.57-1.9-1.57-3.61c0-1.78,0.74-3.08,2.21-3.9c1.47-0.81,3.53-1.22,6.17-1.22 c2.48,0,4.85,0.29,7.1,0.87c2.25,0.58,4.31,1.26,6.17,2.04c0.85-1.63,1.59-3.53,2.21-5.71c0.62-2.17,1.01-4.27,1.17-6.29 c-3.03-1.09-6.02-1.9-8.96-2.45c-2.95-0.54-5.94-0.81-8.96-0.81c-7.3,0-13.06,1.67-17.29,5.01c-4.23,3.34-6.34,7.96-6.34,13.85 c0,4.89,1.22,8.56,3.66,11c2.45,2.45,5.84,4.29,10.19,5.53L341.95,273.24z M272.8,260.79c0.39-3.96,1.59-7.02,3.61-9.2 c2.02-2.17,4.97-3.26,8.85-3.26c3.41,0,6.07,1.15,7.97,3.44c1.9,2.29,2.93,5.3,3.09,9.02H272.8z M311.34,272.31 c0.16-0.85,0.29-2,0.41-3.43c0.12-1.44,0.18-2.89,0.18-4.37c0-4.04-0.58-7.82-1.75-11.35c-1.16-3.53-2.89-6.58-5.18-9.14 c-2.29-2.56-5.06-4.58-8.32-6.05c-3.26-1.47-6.98-2.21-11.18-2.21c-4.81,0-9.02,0.83-12.63,2.5c-3.61,1.67-6.64,3.94-9.08,6.81 c-2.45,2.87-4.29,6.25-5.53,10.13c-1.24,3.88-1.86,8.03-1.86,12.46c0,4.5,0.6,8.65,1.8,12.46c1.2,3.8,3.06,7.08,5.59,9.84 c2.52,2.76,5.78,4.91,9.78,6.46c4,1.55,8.79,2.33,14.38,2.33c7.61,0,14.44-1.16,20.49-3.49c-0.08-2.48-0.43-4.81-1.05-6.99 c-0.62-2.17-1.36-4.04-2.21-5.59c-2.49,0.93-5.1,1.65-7.86,2.15c-2.76,0.51-5.45,0.76-8.09,0.76c-4.81,0-8.69-1.05-11.64-3.14 c-2.95-2.1-4.58-5.47-4.89-10.13H311.34z M215.29,297.23c1.32,0.31,2.72,0.5,4.19,0.58c1.47,0.08,2.79,0.12,3.96,0.12 c1.09,0,2.45-0.04,4.08-0.12c1.63-0.08,3.18-0.23,4.66-0.47l22.82-60.07c-1.94-0.39-3.67-0.62-5.18-0.7 c-1.51-0.08-2.85-0.12-4.02-0.12c-1.48,0-2.95,0.06-4.42,0.17c-1.48,0.12-2.87,0.29-4.19,0.52l-12.92,44.82l-13.16-44.82 c-1.32-0.31-2.76-0.5-4.31-0.58c-1.55-0.08-3.11-0.12-4.66-0.12c-1.16,0-2.54,0.04-4.13,0.12c-1.59,0.08-3.32,0.31-5.18,0.7 L215.29,297.23z M169.77,297.34c2.79,0.47,5.47,0.7,8.03,0.7c2.64,0,5.36-0.23,8.15-0.7v-60.19h-23.98 c-0.46,2.02-0.7,4.07-0.7,6.17c0,1.01,0.06,2.08,0.18,3.2c0.12,1.13,0.29,2.19,0.52,3.2h7.8V297.34z M116.22,297.23 c1.32,0.31,2.72,0.5,4.19,0.58c1.47,0.08,2.79,0.12,3.96,0.12c1.09,0,2.44-0.04,4.07-0.12c1.63-0.08,3.18-0.23,4.66-0.47 l22.82-60.07c-1.94-0.39-3.67-0.62-5.18-0.7c-1.51-0.08-2.85-0.12-4.02-0.12c-1.48,0-2.95,0.06-4.42,0.17 c-1.48,0.12-2.87,0.29-4.19,0.52l-12.92,44.82l-13.16-44.82c-1.32-0.31-2.76-0.5-4.31-0.58c-1.55-0.08-3.1-0.12-4.66-0.12 c-1.17,0-2.54,0.04-4.13,0.12c-1.59,0.08-3.32,0.31-5.18,0.7L116.22,297.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.49,227.68c5.72,0,10.36-4.64,10.36-10.36c0-5.72-4.64-10.36-10.36-10.36c-5.72,0-10.36,4.64-10.36,10.36 C166.13,223.04,170.77,227.68,176.49,227.68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivesLogo);
export default __webpack_public_path__ + "static/media/vives-logo.438119c23dbf1c86a33ae668776f9d98.svg";
export { ForwardRef as ReactComponent };